import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';
import tr from './locales/tr.json';

const apiBase = process.env.REACT_APP_API_URL?.replace(/\/$/, '') ?? 'https://api.abcconstructions.fr/api';

const resources = {
  fr: { translation: fr },
  en: { translation: en },
  tr: { translation: tr },
};

const translationBackend = {
  type: 'backend',
  init: () => {},
  read: async (language: string, namespace: string, callback: (error: unknown, data: object | false | null) => void) => {
    try {
      const response = await fetch(`${apiBase}/translations/${language}`);
      if (!response.ok) {
        throw new Error(`Unable to load translations for '${language}': ${response.status}`);
      }

      const data = await response.json();
      callback(null, data);
    } catch (error) {
      console.warn('Translation backend failed, falling back to bundled locale files.', error);
      callback(error, false);
    }
  },
};

i18n
  .use(LanguageDetector)
  .use(translationBackend as any)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en', 'tr'],
    load: 'languageOnly',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    react: {
      useSuspense: false,
    },
    debug: false,
  });

export default i18n;
